const originalLeftClasses = new Set();

const flipContentSides = () => {
	// Get all elements with either class
	const elements = document.querySelectorAll(
		'.block-content-side-image--left, .block-content-side-image--right'
	);

	elements.forEach((element) => {
		// Store elements that were originally on the left
		if (element.classList.contains('block-content-side-image--left')) {
			originalLeftClasses.add(element);
		}

		// If screen is below 992px, flip sides
		if (window.innerWidth < 768) {
			if (element.classList.contains('block-content-side-image--left')) {
				element.classList.remove('block-content-side-image--left');
				element.classList.add('block-content-side-image--right');
			}
		}
		// If screen is 992px or above, reset elements to their original side
		else if (originalLeftClasses.has(element)) {
			element.classList.remove('block-content-side-image--right');
			element.classList.add('block-content-side-image--left');
		}
	});
};

const controller = {
	init() {
		flipContentSides(); // Initial flip if needed

		// Add event listener for resizing
		window.addEventListener('resize', flipContentSides);
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};

export default controller;
